import { Button, Group, ActionIcon, Tooltip } from "@mantine/core";
import { X, Plus } from "lucide-react";

export interface ReportCreateActionsButtonProps {
    handleCancel: () => void;
    handleSave: () => void;
    isSaving: boolean;
}

export function ReportCreateActionsButton({
    handleCancel,
    handleSave,
    isSaving
}: ReportCreateActionsButtonProps) {
    return (
        <Group justify="flex-end" gap="sm">
            <Tooltip label="Cancel">
                <ActionIcon
                    variant="outline"
                    color="gray"
                    onClick={handleCancel}
                    disabled={isSaving}
                    hiddenFrom="sm"
                    size="lg"
                >
                    <X size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                variant="outline"
                color="gray"
                onClick={handleCancel}
                disabled={isSaving}
                visibleFrom="sm"
                leftSection={<X size={16} />}
            >
                Cancel
            </Button>

            <Tooltip label="Create Report">
                <ActionIcon
                    color="black"
                    c="white"
                    onClick={handleSave}
                    disabled={isSaving}
                    loading={isSaving}
                    hiddenFrom="sm"
                    size="lg"
                >
                    <Plus size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                color="black"
                c="white"
                onClick={handleSave}
                disabled={isSaving}
                loading={isSaving}
                visibleFrom="sm"
                leftSection={<Plus size={16} />}
            >
                Create Report
            </Button>
        </Group>
    );
}
